import { toast } from "react-toastify";
import i18n from "i18next";
import { signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth";
import { getUser, resetUser } from "./userActions";
import { getAlgoliaInfos } from "./algoliaActions"; // <-- Import here
import axios from "../../utils/axiosWrapper";
import {
  AUTH_LOADING,
  AUTH_LOGIN,
  AUTH_LOGIN_FAILURE,
  AUTH_RESET,
  AUTH_SET,
  AUTH_SIGNOUT_FAILURE,
  AUTH_SIGNUP,
  AUTH_UPDATE,
  USER_SET,
  AUTH_ERROR,
  ANALYTICS_RESET,
  CALLS_RESET,
  OPERATORS_RESET,
  ALGOLIA_FETCH,
  ALGOLIA_FETCH_SUCCESS,
} from "../actionTypes";
import { auth } from "../../conf/firebase";
import errorHandler from "../../utils/errorHandler";

export function onAuthChange(userCrediential) {
  return async (dispatch) => {
    if (userCrediential) {
      try {
        const user = await dispatch(getUser(userCrediential.uid)); // 1 firestore user read call
        const algoliaInfos = await dispatch(getAlgoliaInfos());
        console.log({ user });
        if (user) {
          dispatch({
            type: AUTH_SET,
            payload: userCrediential,
          });
          if (algoliaInfos) {
            dispatch({
              type: ALGOLIA_FETCH_SUCCESS,
              payload: algoliaInfos,
            });
          }
        }
      } catch (error) {
        console.log({ error });
        const errorMessage = errorHandler(error);
        dispatch({ type: AUTH_ERROR, payload: errorMessage });
      }
    }
  };
}

export function signin({ email, password }) {
  return async (dispatch) => {
    const toastId = toast.loading(i18n.t("Signing in..."));
    try {
      dispatch({ type: AUTH_LOGIN });
      await signInWithEmailAndPassword(auth, email, password); // 1 firebase authentication user read call
      const algoliaInfos = await dispatch(getAlgoliaInfos());
      toast.update(toastId, {
        render: i18n.t("Welcome to easier"),
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });
      // dispatch({ type: ANALYTICS_RESET }); // TODO: Harry verify this line
    } catch (error) {
      console.log({ error });
      const errorMessage = errorHandler(error);
      dispatch({ type: AUTH_LOGIN_FAILURE, payload: errorMessage });
      toast.update(toastId, {
        render: i18n.t(errorMessage),
        type: "error",
        isLoading: false,
        autoClose: 1000,
      });
    }
  };
}

export function sendPasswordResetEmailLink(email) {
  return async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success(i18n.t("Reset password email sent 👌"), {
        autoClose: 500,
        hideProgressBar: false,
      });
    } catch (error) {
      const errorMessage = errorHandler(error);
      toast.error(i18n.t(errorMessage), { autoClose: 1000 });
    }
  };
}

export function signout() {
  return async (dispatch) => {
    try {
      const toastId = toast.loading(i18n.t("Signing out..."));
      await signOut(auth); // 1 firebase authentication user read
      // TODO: clear all reducers
      const promises = [
        dispatch(resetAuth()),
        dispatch({ type: ANALYTICS_RESET }),
        dispatch({ type: CALLS_RESET }),
        dispatch({ type: OPERATORS_RESET }),
        dispatch(resetUser()),
      ];
      await Promise.all(promises);
      toast.update(toastId, {
        render: i18n.t("Signout successfully."),
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });
    } catch (error) {
      const errorMessage = errorHandler(error);
      dispatch({ type: AUTH_SIGNOUT_FAILURE, payload: errorMessage });
      toast.update(toastId, {
        render: i18n.t(errorMessage),
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });
    }
  };
}

export function resetAuth() {
  return async (dispatch) => {
    dispatch({ type: AUTH_RESET });
  };
}

export function setAuth(auth) {
  return async (dispatch) => {
    dispatch({ type: AUTH_SET, payload: auth });
  };
}

export function resetPassword(uid, password) {
  return async (dispatch) => {
    try {
      const user = auth.currentUser;
      const response = await axios.post("/auth/reset-password", { uid, password }); // 1 firebase authentication write call
      toast.success(i18n.t("User's password updated 👌"), {
        autoClose: 500,
        hideProgressBar: false,
      });
      return response.data;
    } catch (error) {
      const errorMessage = errorHandler(error);
      toast.error(i18n.t(errorMessage), { autoClose: 1000 });
    }
  };
}

export function updateAuthReducer({ prop, value }) {
  return (dispatch) => {
    dispatch({
      type: AUTH_UPDATE,
      payload: { prop, value },
    });
  };
}
